var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadIndigo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Arrow Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.1665 13.667C12.4427 13.6669 12.6667 13.8907 12.6667 14.1668C12.6667 14.4429 12.443 14.6669 12.1668 14.667L3.50014 14.6695C3.224 14.6695 3 14.4457 3 14.1696C3 13.8935 3.22371 13.6695 3.49986 13.6695L12.1665 13.667ZM7.76549 1.34148L7.83333 1.33691C8.08646 1.33691 8.29566 1.52502 8.32877 1.76907L8.33333 1.83691L8.33267 10.9602L10.8139 8.48003C10.9914 8.30253 11.2692 8.28643 11.4649 8.43168L11.521 8.4801C11.6985 8.65763 11.7146 8.93541 11.5693 9.13113L11.5209 9.18721L8.18915 12.5183C8.01172 12.6957 7.73413 12.7119 7.5384 12.5668L7.48232 12.5185L4.14669 9.18741C3.95129 8.99228 3.95108 8.6757 4.14621 8.48031C4.3236 8.30267 4.60136 8.28635 4.7972 8.43145L4.85331 8.47982L7.33267 10.9556L7.33333 1.83691C7.33333 1.58378 7.52144 1.37459 7.76549 1.34148L7.83333 1.33691L7.76549 1.34148Z",
    fill: "#1C3D61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadIndigo);
export default __webpack_public_path__ + "static/media/icon-download-indigo.08229309b88964877c5525933c1a55de.svg";
export { ForwardRef as ReactComponent };